import { useEffect } from "react";
import { Reveal } from "./Reveal";

export const LegalSection = ({ title, children }) => (
  <section className="mt-10">
    <h2 className="font-display text-xl font-bold tracking-tight text-slate-900 sm:text-2xl">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-slate-600 sm:text-base">{children}</div>
  </section>
);

export const LegalLayout = ({ eyebrow, title, updated, testid, children }) => {
  useEffect(() => {
    const prev = document.title;
    document.title = `${title} | PisoScore`;
    return () => {
      document.title = prev;
    };
  }, [title]);

  return (
    <main data-testid={testid} className="bg-white">
      <div className="border-b border-slate-100 bg-slate-50/70">
        <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6 sm:py-20">
          <Reveal>
            <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-emerald-600">{eyebrow}</p>
            <h1 className="font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">{title}</h1>
            <p className="mt-4 text-sm text-slate-500">Última actualización: {updated}</p>
          </Reveal>
        </div>
      </div>
      <Reveal className="mx-auto max-w-3xl px-4 pb-20 pt-4 sm:px-6">{children}</Reveal>
    </main>
  );
};
